import { roterPre } from '@/setting';
import { findFirstMenuUrl } from '@/utils/crmebMenu';
import type { CrmebMenuNode } from '@/utils/crmebMenu';

/** 控制台（dashboard）静态路由 */
export const ADMIN_DASHBOARD_PATH = `${roterPre}/dashboard`;

/** 登录页（对齐 EB permission.js whiteList：`${roterPre}/login`、agent-login；兼留 /login） */
export const ADMIN_LOGIN_PATHS = [`${roterPre}/login`, `${roterPre}/agent-login`, '/login'] as const;

export function isAdminLoginPath(path?: string | null): boolean {
  return !!path && (ADMIN_LOGIN_PATHS as readonly string[]).includes(path);
}

/** 若依遗留首页 path → EB 控制台 */
const LEGACY_HOME_PATHS = new Set(['/', '/index', `${roterPre}/index`]);

/** 登录后 / Logo / 404 等统一解析首页 */
export function resolveAdminHomePath(menuTree?: CrmebMenuNode[] | null): string {
  const url = findFirstMenuUrl(menuTree);
  if (!url || LEGACY_HOME_PATHS.has(url)) {
    return ADMIN_DASHBOARD_PATH;
  }
  return url;
}

/** 规范化 redirect 参数（过滤若依 /index、登录页本身，避免登完又回到登录） */
export function normalizeAdminRedirectPath(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (LEGACY_HOME_PATHS.has(path) || isAdminLoginPath(path)) {
    return undefined;
  }
  return path;
}
